export var LabelKeyTemplates;
(function (LabelKeyTemplates) {
    LabelKeyTemplates["TYPE"] = "destinations_experienceType{type}_label";
    LabelKeyTemplates["LEVEL"] = "destinations_experienceLevel{level}_label";
    LabelKeyTemplates["RENTAL"] = "destinations_experienceVRental{rental}_label";
})(LabelKeyTemplates || (LabelKeyTemplates = {}));
export var LabelKeyPrefixes;
(function (LabelKeyPrefixes) {
    LabelKeyPrefixes["TYPE"] = "{type}";
    LabelKeyPrefixes["LEVEL"] = "{level}";
    LabelKeyPrefixes["RENTAL"] = "{rental}";
})(LabelKeyPrefixes || (LabelKeyPrefixes = {}));
